import { useCallback, useEffect } from "react";
import { toast } from "react-toastify";
import api from "../services/api";
import moment from "moment";
import UserPermission from "../components/UserPermission";

export function useLateNotification() {
    const userPermission = UserPermission();

    const notify = useCallback(({ data }) => {
        const toastConfig = {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        };

        data.forEach(complaint => {
            const daysLate = moment().diff(moment(complaint.datePrevision), 'days');
            const message = `Uma ocorrência do tipo ${complaint.area} está atrasada em ${daysLate} dias`;
            console.log('toast');
            toast.error(message, toastConfig);
        });
    }, []);

    const loadNotifications = useCallback(() => {
        const filter = {
            order: 'datePrevision',
            where: {
                datePrevision: { lte: moment().startOf('day').toISOString() },
                or: [
                    { status: 'Novo' },
                    { status: 'Em análise' }
                ]
            },
            limit: 10
        };

        api.get(`${userPermission}/complaints?filter=${JSON.stringify(filter)}`)
            .then(notify);
    }, [notify, userPermission]);

    useEffect(() => {
        if (userPermission === 'admin' || userPermission === 'manager') {
            loadNotifications();
        }
    }, [userPermission, loadNotifications]);
}